// Start page of age selection
const ageGate = () => {
    const form = document.getElementById("age-form"),
          day = document.getElementById("day"),
          month = document.getElementById("month"),
          year = document.getElementById("year");

    const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");
    const ageErrorPage = isLocal ? 'age-gate-error.html' : `age-gate-error?lang=${LANG}`;

    function checkAge() {
        let dayValue = parseInt(day.value, 10);
        let monthValue = parseInt(month.value, 10);
        let yearValue = parseInt(year.value, 10);

        let birthday = new Date(yearValue, monthValue - 1, dayValue);
        let today = new Date();
        let age = today.getFullYear() - birthday.getFullYear();

        if (today.getMonth() < birthday.getMonth() || (today.getMonth() == birthday.getMonth() && today.getDate() < birthday.getDate())) {
            age--;
        }

        if (age >= 18) {
            localStorage.setItem('ageGate', 'yes');
            document.body.removeChild(document.querySelector('#ageGate'));
            document.body.classList.remove('step_ageGate');
        } else {
            window.location.href = ageErrorPage;
        }
    }

    form.addEventListener("submit", function (event) {
        event.preventDefault();
        checkAge();
    });

    window.onload = function (e) {
        if (document.body.classList.contains('homepage')) {
            document.body.classList.add('step_ageGate');
        }
        if (localStorage.getItem('ageGate') && document.body.classList.contains('homepage')) {
            document.body.removeChild(document.querySelector('#ageGate'));
            document.body.classList.remove('step_ageGate');
        }
    }
}

const waitingPage = document.querySelector('#waitingPage');
const ageSelect = document.querySelectorAll('.form__select');

if (document.body.classList.contains('homepage') && !waitingPage) {
    ageGate();
    ageSelect.forEach((el) => {
        el.addEventListener('click', () => {
            el.classList.toggle('is-active')
        });
    });
}